import React, { useState, useEffect } from 'react';
import "./Form.css";

function FormNYCULogin() {
  const [account, setAccount] = useState('');
  const [password, setPassword] = useState('');
  const [loggedIn, setLoggedIn] = useState(false);
  const [refreshReCaptcha, setRefreshReCaptcha] = useState(false);
  const [reCaptchaValue, setReCaptchaValue] = useState('');

  const handleReCaptcha = (value) => {
    setReCaptchaValue(value);
  };


  // componentDidMount的替代方案
  useEffect(() => {
    // 在這裡加入componentDidMount需要執行的代碼
    handleRefreshReCaptcha();
  }, []);

  // handleRefreshReCaptcha 函數 (如果需要)
  const handleRefreshReCaptcha = () => {
    setRefreshReCaptcha(prev => !prev);
  };

  const handleLinkClick = (e) => {
    e.preventDefault(); // 防止超連結的默認行為
    window.location.href = 'https://id.nycu.edu.tw/o/authorize/?client_id=DyBQq9JBFixNjGVskSQy8fgYL3poWvDIw64tWXwn&response_type=code&scope=profile%20name%20status&redirect_uri=https://va.nycu.edu.tw/';
  };
  const linkStyle = {
    fontSize: '48px', // 設定字體大小
    textAlign: 'center', // 文字置中
    display: 'block', // 讓超連結占滿整個容器寬度
    margin: '0 auto', // 上下邊距為0，左右邊距自動，以實現水平居中
    padding: '10px' // 添加一些內邊距
  };


  return (
    <div>
      <a
        href="#"
        onClick={handleLinkClick}
        style={linkStyle}
      >
        NYCU單一登入入口
      </a>
      <p className="login-instruction">
        本平台登入僅支援國立陽明交通大學教職員。請確保您已登入過國立陽明交通大學資訊技術服務中心諮詢服務組網站評鑑系統。其他單位或人員請使用一般登入。
      </p>
    </div>
  );
};

export default FormNYCULogin;
